<template>
  <div class="outer-box max-w-xl">
    <h4>Update SMS Limit</h4>
    <div class="subtext">⚠️ Please increase the limit only after verifying the agency’s age, SMS usage pattern, volume trends, and compliance history — including opt-out rates. Proceed with caution to avoid potential abuse or deliverability issues.</div>

    <b-alert show variant="info" class="text-left m-3">
      Update the SMS limit locations in a company.
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <b-form @submit.prevent="showConfirmationModal">
        <b-form-group label="Company ID" label-for="companyId">
          <b-form-input
            id="companyId"
            v-model="companyId"
            type="text"
            required
            placeholder="Enter company ID"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="SMS Limit Type for existing Locations" label-for="smsLimitType">
          <b-form-select
            id="smsLimitType"
            v-model="smsLimitType"
            :options="[
              { value: null, text: 'Select an option' },
              { value: 'messages', text: 'Messages' },
              { value: 'segments', text: 'Segments' }
            ]"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="SMS Limit for existing Locations" label-for="smsSendLimit">
          <b-form-input
            id="smsSendLimit"
            v-model.number="smsSendValue"
            type="number"
            min="0"
            placeholder="Enter SMS send limit"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="SMS Limit Unit for existing locations" label-for="smsLimitUnit">
          <b-form-select
            id="smsLimitUnit"
            v-model="smsLimitUnit"
            :options="[
              { value: null, text: 'Select an option' },
              { value: 'daily', text: 'Daily' },
              { value: 'monthly', text: 'Monthly' }
            ]"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="SMS Limit for new locations" label-for="futureSmsLimitValue">
          <b-form-input
            id="futureSmsLimitValue"
            v-model.number="futureSmsLimitValue"
            type="number"
            min="0"
            placeholder="Enter future SMS limit value"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="SMS Limit Type for new locations" label-for="futureSmsLimitType">
          <b-form-select
            id="futureSmsLimitType"
            v-model="futureSmsLimitType"
            :options="[
              { value: null, text: 'Select an option' },
              { value: 'messages', text: 'Messages' },
              { value: 'segments', text: 'Segments' }
            ]"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="SMS Limit Unit for new locations" label-for="futureSmsLimitUnit">
          <b-form-select
            id="futureSmsLimitUnit"
            v-model="futureSmsLimitUnit"
            :options="[
              { value: null, text: 'Select an option' },
              { value: 'daily', text: 'Daily' },
              { value: 'monthly', text: 'Monthly' }
            ]"
          ></b-form-select>
        </b-form-group>


        <b-button type="submit" variant="primary" class="mt-3">
          Update SMS Limit
        </b-button>
      </b-form>
    </div>

    <!-- Confirmation Modal -->
    <b-modal
      v-model="showModal"
      title="Confirm SMS Limit Update"
      @ok="submitSMSLimitChange"
      ok-title="Confirm"
      cancel-title="Cancel"
    >
      <div class="confirmation-details">
        <p><strong>Company ID:</strong> {{ companyId }}</p>
        <p><strong>Current SMS Limit Type:</strong> {{ smsLimitType }}</p>
        <p><strong>Current SMS Limit:</strong> {{ smsSendValue }}</p>
        <p><strong>Current SMS Limit Unit:</strong> {{ smsLimitUnit }}</p>
        <p><strong>SMS Limit Value for new locations:</strong> {{ futureSmsLimitValue }}</p>
        <p><strong>SMS Limit Type for new locations:</strong> {{ futureSmsLimitType }}</p>
        <p><strong>SMS Limit Unit for new locations:</strong> {{ futureSmsLimitUnit }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ISVService } from "@/services";
export default {
  data() {
    return {
      companyId: null,
      futureSmsLimitValue: null,
      futureSmsLimitType: null,
      futureSmsLimitUnit: null,
      smsLimitType: null,
      smsSendValue: null,
      smsLimitUnit: null,
      showModal: false
    };
  },
  methods: {
    showConfirmationModal() {
      this.showModal = true;
    },
    submitSMSLimitChange() {
      const payload = {
        smsSendValue: this.smsSendValue,
        smsLimitType: this.smsLimitType,
        smsLimitUnit: this.smsLimitUnit,
        futureSmsLimitValue: this.futureSmsLimitValue,
        futureSmsLimitType: this.futureSmsLimitType,
        futureSmsLimitUnit: this.futureSmsLimitUnit,
      }
      const companyId = this.companyId;

      ISVService.updateSMSLimit(companyId, payload).then((response) => {
          this.uploadResponse = response.data;
          // show success message
          this.$bvToast.toast('SMS limit updated successfully', {
              title: 'Success',
              variant: 'success',
              solid: true
          });

          // clear the form
          this.companyId = null;
          this.smsLimitType = null;
          this.smsSendValue = null;
          this.smsLimitUnit = null;
          this.futureSmsLimitValue = null;
          this.futureSmsLimitType = null;
          this.futureSmsLimitUnit = null;
          this.showModal = false;
      }).catch((error) => {
          console.error(error);
          this.$bvToast.toast(error.response?.data?.message || 'Failed to update SMS limit', {
              title: 'Error',
              variant: 'danger',
              solid: true
          });
      });
    }
  },
};
</script>

<style>
.confirmation-details {
  text-align: left;
}
.confirmation-details p {
  margin-bottom: 0.5rem;
}

.subtext {
  background-color: #ffebee;
  padding: 8px;
  margin: 8px 0;
  border-radius: 4px;
  color: #d32f2f;
}
</style> 